var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    modal\n    absolute\n    left-0\n    top-0\n    w-screen\n    h-screen\n    flex\n    items-center\n    justify-center\n    z-40\n  "},[_c('div',{staticClass:"z-50"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }